import { Card } from "antd";
import { Component, ReactNode } from "react";

export interface ICardComponent {
  data: {
    title: string;
    mainTitle?: string;
    extra: ReactNode;
    children: ReactNode;
  };
}

export default class CardComponent extends Component<ICardComponent> {
  constructor(props: ICardComponent) {
    super(props);
  }

  render(): ReactNode {
    const { children, extra, title, mainTitle } = this.props?.data;
    return (
      <div
        style={{
          flex: 1,
          height: "100vh",
          marginBottom: 70,
        }}
        className="px-2 py-1"
      >
        <Card
          title={null}
          extra={extra}
          variant="borderless"
          style={{
            border: 0,
          }}
          styles={{
            body: {
              padding: 10,
            },
          }}
        >
          <section className="flex flex-col justify-center items-start w-full">
            <h1 className="font-[600] xl:text-[12px] text-[11px] text-[#909090]">
              {mainTitle}
            </h1>
            <p className="font-[600] xl:text-[14px] text-[12px]">{title}</p>
          </section>
          <br />
          {children}
        </Card>
      </div>
    );
  }
}
